module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Space Gray Aluminum + Black Cool Gray Nike Open.3b8d0a93.png";